/** Matches Property Service's managed-feature write policies. Reads and explicit completion/revocation remain available. */
export const MANAGED_WRITE_FEATURES: Record<string, string> = {
  PROPERTY_MANAGEMENT: 'Property management', UNIT_MANAGEMENT: 'Unit management', PROPERTY_MEDIA: 'Property media',
  TENANT_MANAGEMENT: 'Tenant management', OWNER_MANAGEMENT: 'Owner management', CONTACT_MANAGEMENT: 'Contact management',
  LEASE_MANAGEMENT: 'Lease management', LEASE_TEMPLATES: 'Lease templates', RENTAL_APPLICATIONS: 'Rental applications',
  STAFF_MANAGEMENT: 'Staff management', DOCUMENT_MANAGEMENT: 'Document management',
};
export const ENFORCED_PLAN_FEATURES = ['ACCOUNTING', 'CUSTOM_BRANDING', 'OWNER_PORTAL', 'INSPECTION_AI_REPORTS',
  'COMMUNICATION_ANNOUNCEMENTS', 'COMMUNICATION_AI', ...Object.keys(MANAGED_WRITE_FEATURES)];

export function featurePolicyLabel(code: string): string {
  if (MANAGED_WRITE_FEATURES[code]) return 'Enforced for new and changed records';
  if (ENFORCED_PLAN_FEATURES.includes(code)) return 'Enforced for protected actions';
  if (['API_ACCESS', 'CUSTOM_DOMAIN', 'MAINTENANCE_VENDOR_PORTAL'].includes(code)) return 'Reserved — not available yet';
  if (['UNLIMITED_ORGANIZATIONS', 'UNLIMITED_PROPERTIES'].includes(code)) return 'Use the separate Unlimited limit setting';
  if (['NOTIFICATIONS', 'SECURITY_SESSIONS'].includes(code)) return 'Essential access — always available';
  if (['EMAIL_SUPPORT', 'PRIORITY_SUPPORT'].includes(code)) return 'Service offering — not an access restriction';
  return 'Informational — not enforced yet';
}

export function managedFeatureForRoute(url: string): string | null {
  const path = url.split(/[?#]/, 1)[0];
  if (/^\/properties\/[^/]+\/units(?:\/|$)/.test(path)) return 'UNIT_MANAGEMENT';
  if (/^\/leases\/templates(?:\/|$)/.test(path)) return 'LEASE_TEMPLATES';
  const root = path.split('/')[1];
  return ({ properties: 'PROPERTY_MANAGEMENT', tenants: 'TENANT_MANAGEMENT', owners: 'OWNER_MANAGEMENT',
    contacts: 'CONTACT_MANAGEMENT', applications: 'RENTAL_APPLICATIONS', leases: 'LEASE_MANAGEMENT',
    staff: 'STAFF_MANAGEMENT', documents: 'DOCUMENT_MANAGEMENT' } as Record<string, string>)[root] ?? null;
}
